import React, {Component} from 'react';
import '../../../local_node_modules/react-select/dist/react-select.css';
import 'rc-select/assets/index.css';
import {Decimal} from 'decimal.js';
import {Card, Modal, ModalFooter, ModalHeader, UncontrolledTooltip} from 'reactstrap';
import {deepCopyObject} from "../../../helper/helper";
import {validateField} from "../../../common/validation";
import NumberFormat from "react-number-format";
import Select2, {Option} from "rc-select/es";
import DespatchLines from "./DespatchLines";
import {isValidDespatchLine} from "../../../common/componentValidation";
import Alert from 'react-s-alert';


class DespatchLineModal extends Component {

    constructor(props) {
        super(props);
        this.state = {
            error: {},
        };
        this.validateField = this.validateField.bind(this);
        this.validateMessage = this.validateMessage.bind(this);
        this.validateClass = this.validateClass.bind(this);
        this.onChange = this.onChange.bind(this);
        this.setDespatchLine = this.setDespatchLine.bind(this);
    }

    componentDidMount() {
        let despatchLine = this.props.despatchLine;

        this.setState({
            modal: this.props.modal,
            despatchLine: despatchLine
        });
    }


    validateField(e) {
        let id = e.target.id;
        let rule = e.target.dataset.vdata;
        let boundary = e.target.dataset.vlength;
        let result = validateField(rule, boundary, e.target.value);
        let error = this.state.error;
        error = Object.assign(error, {[id]: result});
        this.setState({error});
    }

    validateClass(id) {
        let error = this.state.error;
        return (error[id] === undefined ? "" : (error[id].valid ? " has-success" : " has-danger"));
    }

    validateMessage(id) {
        let error = this.state.error;
        return (error[id] === undefined ? '' : (error[id].message));
    }

    setDespatchLine(e) {
        e.preventDefault();
        let despatchLine = deepCopyObject(this.state.despatchLine);
        let result = isValidDespatchLine(despatchLine);
        let error = result.error;
        let valid = result.valid;
        if (valid) {
            this.props.listener(despatchLine);
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 3000
            });
            this.setState({error});
        }
    }

    //unused for the moment




    onChange(e) {
        let despatchLine = deepCopyObject(this.state.despatchLine);
        despatchLine[e.target.name] = (e.target.name === "quantity" || e.target.name === "unitPrice" || e.target.name === "innerItemCount" || e.target.name === "outstandingQuantity") ?
                                        (new Decimal(e.target.value)).toNumber() :
                                        ((e.target.name === "barcode") || (e.target.name === "orderLineReference")) ? e.target.value.replace( /\D+/g, '') :e.target.value;
        despatchLine=DespatchLines.calculate(despatchLine);
        this.setState({despatchLine});
    }


    render() {
        let despatchLine = this.state.despatchLine;
        if (!despatchLine) return null;
        return (
            <Modal isOpen={this.state.modal} toggle={this.props.toggle} size="lg" backdrop={false}>
                <ModalHeader toggle={this.props.toggle}>{(this.props.index + 1) + "."} Satır Bilgileri</ModalHeader>
                <Card className="">
                    <div className=" row col-sm-12" style={{marginLeft: '0px', marginTop: '20px'}}>
                        <div className="col-sm-6 ">
                            <div className="row">
                                <label className="col-sm-4 col-form-label">Ürün Adı</label>
                                <div className="col-sm-8">
                                    <div className={"form-group" + this.validateClass('itemName')}>
                                        <input id="itemName"
                                               name="itemName"
                                               type="text"
                                               data-vlength="1,255"
                                               className="form-control"
                                               onBlur={this.validateField}
                                               placeholder="Ürün Adı" value={despatchLine.itemName}
                                               onChange={(e) => this.onChange(e)}/>
                                        {this.validateMessage('itemName') !== "" &&
                                        <UncontrolledTooltip placement="right" target={'itemName'}
                                                             delay={0}>
                                            {this.validateMessage('itemName')}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-sm-4 col-form-label">Miktar</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <NumberFormat id={'quantity'}
                                                      value={despatchLine.quantity}
                                                      allowNegative={false}
                                                      isNumericString={true}
                                                      allowEmptyFormatting={false}
                                                      decimalScale={9}
                                                      thousandSeparator={'.'}
                                                      decimalSeparator={','}
                                                      displayType="input"
                                                      isAllowed={values => {
                                                          return (values.value === "" ? false : true);
                                                      }}
                                                      placeholder="quantity"
                                                      renderText={value => {
                                                          value.replace(/\./g, ',')
                                                      }}
                                                      onValueChange={(e) => this.onChange({
                                                          target: {
                                                              value: e.value,
                                                              name: "quantity"
                                                          }
                                                      })}
                                                      className="form-control"/>
                                    </div>
                                </div>
                            </div>


                            <div className="row">
                                <label className="col-sm-4 col-form-label">Birim Fiyat</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <NumberFormat id={'unitPrice'}
                                                      value={despatchLine.unitPrice}
                                                      allowNegative={true}
                                                      isNumericString={true}
                                                      allowEmptyFormatting={false}
                                                      decimalScale={9}
                                                      thousandSeparator={'.'}
                                                      decimalSeparator={','}
                                                      displayType="input"
                                                      isAllowed={values => {
                                                          return (values.value === "" ? false : true);
                                                      }}
                                                      placeholder="unitPrice"
                                                      renderText={value => {
                                                          value.replace(/\./g, ',')
                                                      }}
                                                      onValueChange={(e) => this.onChange({
                                                          target: {
                                                              value: e.value,
                                                              name: "unitPrice"
                                                          }
                                                      })}
                                                      className="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-sm-4 col-form-label">İç Adet</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <NumberFormat id={'innerItemCount'}
                                                      value={despatchLine.innerItemCount ? despatchLine.innerItemCount : 0}
                                                      allowNegative={false}
                                                      isNumericString={true}
                                                      allowEmptyFormatting={false}
                                                      decimalScale={0}
                                                      thousandSeparator={'.'}
                                                      decimalSeparator={','}
                                                      displayType="input"
                                                      isAllowed={values => {
                                                          return ((values.value === "" || values.value.length > 4 )? false : true);
                                                      }}
                                                      placeholder=""
                                                      renderText={value => {
                                                          value.replace(/\./g, ',')
                                                      }}
                                                      onValueChange={(e) => this.onChange({
                                                          target: {
                                                              value: e.value,
                                                              name: "innerItemCount"
                                                          }
                                                      })}
                                                      className="form-control"/>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-sm-6 ">

                            <div className="row">
                                <label className="col-sm-4 col-form-label">Birim</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <Select2
                                            id="unit"
                                            placeholder="Birim Seçiniz"
                                            defaultValue="C62"
                                            value={despatchLine.unit}
                                            style={{width: "100%"}}
                                            dropdownMenuStyle={{maxHeight: 200}}
                                            optionLabelProp="children"
                                            notFoundContent="Kayıt bulunamadı"
                                            optionFilterProp="text"
                                            getPopupContainer={(node) => {
                                                return node.parentNode;
                                            }}
                                            onChange={(e) => this.onChange({
                                                target: {
                                                    value: e,
                                                    name: "unit"
                                                }
                                            })}>
                                            {this.props.unitCodes.map(unitCode =>
                                                <Option text={unitCode.longCode} value={unitCode.shortCode}
                                                        title={unitCode.longCode}>{unitCode.longCode}</Option>
                                            )}
                                        </Select2>
                                    </div>
                                </div>
                            </div>

                            <div className=" row">

                                <label className="col-sm-4 col-form-label">Ürün/Hizmet Tutarı</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <NumberFormat id="lineExtensionAmount"
                                                      value={despatchLine.lineExtensionAmount}
                                                      allowNegative={false}
                                                      isNumericString={true}
                                                      decimalScale={2}
                                                      thousandSeparator={'.'}
                                                      decimalSeparator={','}
                                                      suffix={this.props.suffix}
                                                      disabled
                                                      displayType="input"
                                                      isAllowed={values => {
                                                          return (values.value === "" ? false : true);
                                                      }}
                                                      placeholder="lineExtensionAmount"
                                                      renderText={value => {
                                                          value.replace(/\./g, ',')
                                                      }}
                                                      onValueChange={(e) => this.onChange({
                                                          target: {
                                                              value: e.value,
                                                              name: "lineExtensionAmount"
                                                          }
                                                      })}
                                                      className="form-control"/>
                                    </div>
                                </div>
                            </div>

                            <div className="row">
                                <label className="col-sm-4 col-form-label">Stok Kodu</label>
                                <div className="col-sm-8">
                                    <div className={"form-group" + this.validateClass('stockCode')}>
                                        <input id="stockCode"
                                               name="stockCode"
                                               type="text"
                                               data-vlength="1,255"
                                               disabled={true}
                                               className="form-control"
                                               onBlur={this.validateField}
                                               placeholder="Stok Kodu" value={despatchLine.itemCode}
                                               onChange={(e) => this.onChange(e)}/>
                                        {this.validateMessage('stockCode') !== "" &&
                                        <UncontrolledTooltip placement="right" target={'stockCode'}
                                                             delay={0}>
                                            {this.validateMessage('stockCode')}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-sm-4 col-form-label">Satır Açıklaması</label>
                                <div className="col-sm-8">
                                    <div className={"form-group" + this.validateClass('lineExplanation')}>
                                        <input id="lineExplanation"
                                               name="lineExplanation"
                                               type="text"
                                               disabled={false}
                                               className="form-control"
                                               maxLength="250"
                                               placeholder="Satır Açıklaması" value={despatchLine.lineExplanation}
                                               onChange={(e) => this.onChange(e)}/>
                                        {this.validateMessage('lineExplanation') !== "" &&
                                        <UncontrolledTooltip placement="right" target={'lineExplanation'}
                                                             delay={0}>
                                            {this.validateMessage('lineExplanation')}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>

                        </div>

                    </div>
                    <hr/>
                    <div className=" row col-sm-12" style={{marginLeft: '0px', marginTop: '20px'}}>
                        <div className="col-sm-6 ">

                            <div className="row">
                                <label className="col-sm-4 col-form-label">Son.Gönd. Sebebi</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <input id={'outstandingReason'}
                                               type="text"
                                               className="form-control"
                                               placeholder=""
                                               value={despatchLine.outstandingReason}
                                               onChange={(e) => this.onChange({
                                                   target: {
                                                       value: e.target.value,
                                                       name: "outstandingReason"
                                                   }
                                               })}/>
                                        {this.validateMessage('outstandingReason') !== "" &&
                                        <UncontrolledTooltip placement="right"
                                                             target={"outstandingReason"} delay={0}>
                                            {this.validateMessage("outstandingReason")}
                                        </UncontrolledTooltip>}
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-sm-4 col-form-label">Müşteri Ürün Kodu</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <input id="buyersItemIdentification"
                                               name="buyersItemIdentification"
                                               type="text"
                                               data-vlength="1,50"
                                               className="form-control"
                                               placeholder="Müşteri Ürün Kodu" value={despatchLine.buyersItemIdentification}
                                               onChange={(e) => this.onChange(e)}/>
                                    </div>
                                </div>
                            </div>

                        </div>

                        <div className="col-sm-6 ">

                            <div className="row">
                                <label className="col-sm-4 col-form-label">Son.Gönd. Miktar</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <NumberFormat id={'outstandingQuantity'}
                                                      value={despatchLine.outstandingQuantity || ""}
                                                      allowNegative={false}
                                                      isNumericString={true}
                                                      allowEmptyFormatting={false}
                                                      decimalScale={9}
                                                      thousandSeparator={'.'}
                                                      decimalSeparator={','}
                                                      displayType="input"
                                                      isAllowed={values => {
                                                          return (values.value !== "");
                                                      }}
                                                      placeholder=""
                                                      renderText={value => {
                                                          value.replace(/\./g, ',')
                                                      }}
                                                      onValueChange={(e) => this.onChange({
                                                          target: {
                                                              value: e.value,
                                                              name: "outstandingQuantity"
                                                          }
                                                      })}
                                                      className="form-control"/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-sm-4 col-form-label">Sipariş No</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <input id="orderLineReference"
                                               name="orderLineReference"
                                               type="text"
                                               data-vlength="1,25"
                                               maxLength="25"
                                               className="form-control"
                                               placeholder="Sipariş Kodu" value={despatchLine.orderLineReference}
                                               onChange={(e) => this.onChange(e)}/>
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                <label className="col-sm-4 col-form-label">Barkod</label>
                                <div className="col-sm-8">
                                    <div className="form-group">
                                        <input id="barcode"
                                               name="barcode"
                                               type="text"
                                               data-vlength="1,13"
                                               maxLength="13"
                                               className="form-control"
                                               placeholder="Barkod" value={despatchLine.barcode}
                                               onChange={(e) => this.onChange(e)}/>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card>
                <ModalFooter className="">
                    <div className="col-sm-2 row ">
                        <button type="button" className="TekBtn vazgec"
                                style={{
                                    background: 'linear-gradient(rgba(125, 125, 125, 0.57), rgb(111, 111, 111))',
                                    padding: '10px 45px 10px 21px'
                                }}
                                onClick={this.props.toggle}>İptal
                        </button>
                    </div>
                    <div className="col-sm-1 row"></div>
                    <div className="col-sm-9 row ">
                        <div className="" style={{marginRight: '0px', marginLeft: 'auto'}}>
                            <button type="button" className=" TekBtn kaydet" style={{padding: '10px 42px 10px 10px'}}
                                    onClick={(e) => this.setDespatchLine(e)}>Kaydet ve Kapat
                            </button>
                        </div>

                    </div>
                </ModalFooter>
            </Modal>
        );
    }
}

export default DespatchLineModal;

